
<div class="loader-container">
	<img *ngIf="imageSrc" [src]="imageSrc" [ngClass]="{'with-progress': loading}" />

	<div *ngIf="loading" class="progress-bar" [ngClass]="{'with-image': imageSrc}">
		<span class="progress-value"></span>
	</div>
</div>